import React, { useContext } from 'react'
import { ChangePresentContext, MedPlanContext } from '../../SingleEvent'
import Grid from '@mui/material/Grid'
import DestinationPicker from './DestinationPicker'

const NearestED = ({ destinationOptions, loadOptions }) => {
  const { medPlan, setMedPlan } = useContext(MedPlanContext)
  const { changesPresent, setChangesPresent } = useContext(ChangePresentContext)

  return (
    <Grid item xs={12} lg={4}>
      <DestinationPicker
        value={medPlan?.nearestED ?? null}
        label="Nearest Emergency Department"
        type="Emergency Department"
        destinationOptions={destinationOptions}
        loadOptions={loadOptions}
        onChange={(e, newValue) => {
          setMedPlan((prev) => ({
            ...prev,
            nearestED: newValue,
          }))
          !changesPresent && setChangesPresent(true)
        }}
        onEditSubmit={(newValue) => {
          setMedPlan((prev) => ({
            ...prev,
            nearestED: newValue,
          }))
          !changesPresent && setChangesPresent(true)
        }}
      />
    </Grid>
  )
}

export default React.memo(NearestED)
